import Vue from 'vue'
import Router from 'vue-router'
// import { getAuth } from 'firebase/auth'

import LoginPage from '../views/LoginView.vue'
// import AudienceBasePage from '../components/Audiences/AudienceBasePage.vue';
import TalkTrendBasePage from '../components/TalkTrend/TalkTrendBasePage.vue';
import PerformanceBasePage from '../components/Performance/PerformanceBasePage';
import ORTBasePage from '../components/ORT/ORTBasePage';
import SweetSpotBasePage from '../components/SweetSpot/SweetSpotBasePage.vue';
import AdminBasePage from '../components/Admin/AdminBasePage';
import SignUpPage from '../views/SignUpView.vue'
import FullPageLoad from '../views/FullPageLoad.vue';
import WelcomePage from '../views/Welcome.vue';
import { authGuard } from '../auth/authGuard';

Vue.use(Router)

const router = new Router({
    routes : [
        {
          path: '*',
          redirect: '/login'
        },
        {
          path: '/',
          redirect: '/login'
        },
        {
        path: '/audience',
        name: 'Audience',
        component: TalkTrendBasePage,
          meta: {
              requiresAuth: true,
              title: 'Docma',
              hideNavbar: false,
          },
        beforeEnter: authGuard
        },
        {
          path: '/performance',
          name: 'Performance',
          component: PerformanceBasePage,
            meta: {
                requiresAuth: true,
                title: 'Docma',
                hideNavbar: false,
            },
            beforeEnter: authGuard
        },
        {
          path: '/ort',
          name: 'ORT',
          component: ORTBasePage,
            meta: {
                requiresAuth: true,
                title: 'Docma',
                hideNavbar: false,
            },
            beforeEnter: authGuard
        },
        {
          path: '/sweetspot',
          name: 'SweetSpot',
          component: SweetSpotBasePage,
            meta: {
                requiresAuth: true,
                title: 'Docma',
                hideNavbar: false,
            },
            beforeEnter: authGuard
        },
        {
          path: '/admin',
          name: 'Admin',
          component: AdminBasePage,
            meta: {
                requiresAuth: true,
                title: 'Docma',
                hideNavbar: false,
            },
            beforeEnter: authGuard
        },
        {
          path: '/login',
          name: 'Login',
        //   redirect: '/ServerMaintenance',
          component: LoginPage,
          meta: {
              title: 'Docma',
              hideNavbar: true,
          }
        },
        {
          path: '/signup',
          name: 'SignUp',
          component: SignUpPage,
          meta: {
            title: 'Docma',
            hideNavbar: true,
          }
        },
        {
          path: '/load',
          name: 'FullPageLoad',
          component: FullPageLoad,
          meta: {
            title: 'Docma',
            hideNavbar: true
          }
        },
        {
          path: '/welcome',
          name: 'Welcome',
          component: WelcomePage,
          meta: {
            title: 'Docma',
            hideNavbar: false
          }
        }
    ]
});


export default router;
